import React from 'react'

export default function EMARLegend(props) {
  const { displayLegend = true, testId } = props

  if (!displayLegend) return null

  const legendCodes = [
    'A: Absent',
    'AT: Already Taken',
    'LO: Left Out (only if risk assessed)',
    'N/V: Nausea or Vomiting',
    'R: Refused',
    'RD: Refused & Destroyed',
    'VP: Verbal Prompt',
    'O: Other'
  ]

  return (
    <div
      style={styles.legendContainer}
      data-testid={testId ? `${testId}-emar-legend` : 'emar-legend'}
    >
      {legendCodes.map((code, index) => (
        <div
          style={styles.legendCode}
          key={index}
          data-testid={
            testId
              ? `${testId}-emar-legend-code-${index}`
              : `emar-legend-code-${index}`
          }
        >
          {code}
        </div>
      ))}
    </div>
  )
}

const styles = {
  legendCode: {
    fontSize: 12,
    lineHeight: '18px',
    marginRight: 8
  },
  legendContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  }
}
